export const style = {
  Typography: {
    sx: {
      color: 'text.primary',
    },
  },
  IconWrapper: {
    sx: {
      '.MuiButton-startIcon': {
        margin: 0,
      },
      '& .MuiSvgIcon-root': {
        color: 'action.active',
      },
    },
  },
  BoxWrapper: {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  BoxContainer: {
    sx: {
      backgroundColor: '#F3F4F6',
      py: 3,
      borderRadius: 1,
      mb: 3,
    },
  },
  row: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      pb: 2,
      '& .MuiInput-underline::before': {
        borderBottom: 0,
      },
      '& .MuiInput-underline::hover': {
        borderBottom: 0,
      },
    },
  },
  Select: {
    sx: {
      background: '#F3F4F6',
      padding: '9px 0px',
    },
  },
  iconComponent: {
    sx: {
      height: '18px',
      width: '18px',
    },
  },
  menuItemLabel: {
    sx: {
      fontWeight: 600,
    },
  },
  loader: {
    loaderSize: 26,
    sx: {
      marginRight: '20px',
      marginTop: '4px',
    },
  },
} as const;
